<template>
  <svg width="20" height="19" viewBox="0 0 20 19">
    <rect
      x="2.857"
      y="8.357"
      width="12.571"
      height="1.571"
      rx=".786"
      transform="translate(.857 .333)"
      fill="#000"
      fill-rule="evenodd"
    />
  </svg>
</template>
